var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusGold = function SvgPlusGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.565 5.444v7.992h7.99v1.556h-7.99v7.99h-1.556v-7.99H6.017v-1.556h7.992V5.444z",
    fill: "#FFC83E",
    fillRule: "evenodd"
  })));
};
export { SvgPlusGold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOSAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNS41NjUgNS40NDR2Ny45OTJoNy45OXYxLjU1NmgtNy45OXY3Ljk5aC0xLjU1NnYtNy45OUg2LjAxN3YtMS41NTZoNy45OTJWNS40NDR6IiBmaWxsPSIjRkZDODNFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";